<template>
  <v-content>
    <div class="staticHero">
      <v-img
        :aspect-ratio="16 / 9"
        max-height="500"
        src="../assets/images/01carousel.jpg"
      >
        <v-row align="end" class="lightbox white--text pa-2 fill-height">
          <v-col>
            <v-container>
              <h2 class="contactH2">Контакти</h2>
            </v-container>
          </v-col>
        </v-row>
      </v-img>
    </div>

    <div class="block contactDiv">
      <v-snackbar :timeout="-1" :value="true" color="success">
        <i class="contactItalic">тел. 0895-156-101</i>
      </v-snackbar>
      <v-container>
        <h2 class="text-center" style="margin-block: inherit">
          Направи запитване:
        </h2>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          action="https://formsubmit.co/del.nikol19@gmail.com"
          method="POST"
        >
          <v-text-field
            v-model="name"
            :counter="10"
            :rules="nameRules"
            label="Име"
            name="name"
            required
          ></v-text-field>

          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="Имейл адрес"
            required
            name="email"
          ></v-text-field>
          <!-- <v-snackbar v-model="snackbar"> 
          "http://localhost:8080/success"  -->
          <input
            type="hidden"
            name="_next"
            value="https://nika19du.github.io/guest-house-nikol/#/success"
          />
          <!-- </v-snackbar> -->
          <v-textarea
            name="message"
            label="Съобщения"
            :rules="messageRules"
            required
          ></v-textarea>

          <v-btn
            :disabled="!valid"
            color="success"
            class="mr-4"
            @click="validate"
            type="submit"
          >
            Изпрати
          </v-btn>

          <v-btn color="error" class="mr-4" @click="reset"> Нулирай </v-btn>
        </v-form>
        <h3 style="margin: initial; margin-top: revert">
          Адрес: <i>гр. Хисаря 4180 | Ул: "Васил Петрович 17"</i>
        </h3>
        <h3>
          Електронна поща:
          <i>del.nikol19@gmail.com</i>
        </h3>
      </v-container>
    </div>

    <div class="googlemap">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1800.2121023993006!2d24.712945917568966!3d42.50443637377664!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40a9eba410158487%3A0xb9473112ed67c68f!2z0JrRitGJ0LAg0LfQsCDQs9C-0YHRgtC4INCd0LjQutC-0Ls!5e0!3m2!1sen!2sbg!4v1625408975681!5m2!1sen!2sbg"
        width="100%"
        height="460"
      ></iframe>
    </div>
  </v-content>
</template>

<script>
export default {
  name: "Contact",
  data: () => ({
    valid: true,
    name: "",
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    message: "",
    messageRules: [
      (v) => !!v || "Message is required",
      (v) => (v && v.length >= 10) || "Message must be more than 10 characters",
    ],
  }),
  mounted() {
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "https://www.google.com/recaptcha/api.js"
    );
    document.head.appendChild(recaptchaScript);
    window.addEventListener("load", function () {
      console.log("All assets are loaded");
      this.toastr.success("Поздравления! Успешна изпратена заявка!", {
        showCloseButton: true,
      });
    });
  },
  methods: {
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
  },
};
</script>

